/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkDocxOutputFormatEnum } from '../models/work-docx-output-format-enum';
import { WorkGenerateFromImagesDto } from '../models/work-generate-from-images-dto';
import { WorkGenerateFromTemplateV1Dto } from '../models/work-generate-from-template-v-1-dto';

@Injectable({ providedIn: 'root' })
export class WorkDocumentsGeneratorService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documentsGeneratorV1ControllerGenerateFromTemplate()` */
  static readonly DocumentsGeneratorV1ControllerGenerateFromTemplatePath = '/v1/documents-generator';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsGeneratorV1ControllerGenerateFromTemplate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsGeneratorV1ControllerGenerateFromTemplate$Response(
    params: {
      format: WorkDocxOutputFormatEnum;
      body: WorkGenerateFromTemplateV1Dto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<{
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsGeneratorService.DocumentsGeneratorV1ControllerGenerateFromTemplatePath, 'post');
    if (params) {
      rb.query('format', params.format, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsGeneratorV1ControllerGenerateFromTemplate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsGeneratorV1ControllerGenerateFromTemplate(
    params: {
      format: WorkDocxOutputFormatEnum;
      body: WorkGenerateFromTemplateV1Dto
    },
    context?: HttpContext
  ): Observable<{
}> {
    return this.documentsGeneratorV1ControllerGenerateFromTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /** Path part for operation `documentsGeneratorV1ControllerGeneratePdfFromImages()` */
  static readonly DocumentsGeneratorV1ControllerGeneratePdfFromImagesPath = '/v1/documents-generator/generatePdfFromImages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsGeneratorV1ControllerGeneratePdfFromImages()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsGeneratorV1ControllerGeneratePdfFromImages$Response(
    params: {
      body: WorkGenerateFromImagesDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<{
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsGeneratorService.DocumentsGeneratorV1ControllerGeneratePdfFromImagesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsGeneratorV1ControllerGeneratePdfFromImages$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsGeneratorV1ControllerGeneratePdfFromImages(
    params: {
      body: WorkGenerateFromImagesDto
    },
    context?: HttpContext
  ): Observable<{
}> {
    return this.documentsGeneratorV1ControllerGeneratePdfFromImages$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

}
